import React from "react";
import { useNavigate } from "react-router-dom";
import { CardMedia, Input, TextField, Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useState, ChangeEvent } from "react";
import CloseIcon from '@mui/icons-material/Close';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const AddSubadmin = () => {

  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [selectField1, setSelectField1] = React.useState('default');
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Sub-Admin</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {' '} - Add Sub-Admin
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label htmlFor="icon-button-file">Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/user_placeholder.png" alt="icon" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            <div className="control_group w_33">
              <label htmlFor="name">Name</label>
              <TextField id="name" placeholder="Enter Name" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="email">Email Id</label>
              <TextField id="email" placeholder="Enter Email Id" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="phone">Phone Number</label>
              <PhoneInput
                inputProps={{ id: "phone" }}
                country={"in"}
                placeholder="Enter Phone Number"
                enableSearch={false}
                autoFormat={false}
                inputStyle={{ width: "100%" }}
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="role">Role</label>
              <Select
                id="role"
                fullWidth
                value={selectField1}
                onChange={handleChange1}
              >
                <MenuItem disabled value="default">
                  Select Role
                </MenuItem>
                <MenuItem value={10}>Role 1</MenuItem>
                <MenuItem value={20}>Role 2</MenuItem>
                <MenuItem value={30}>Role 3</MenuItem>
              </Select>
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubadmin;
